(() => {
    const initStateReady = () => {
        const submit = document.querySelector('.form-navigation .next button.btn')
        if (submit) {
            document.onkeydown = function(e) {
                if (e.key === "Enter") {
                    if(typeof submit.click == 'function') {
                        submit.click()
                    } else if(typeof submit.onclick == 'function') {
                        submit.onclick()
                    }
                    else {
                        submit.dispatchEvent(new Event('click'));
                    }
                    e.preventDefault();
                }
            }
        }
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;

        initStateReady();
    });
})();
